import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-0 bg-navy" data-id="element-97" data-mp="8mn4mdpzojyr">
      <div className="mx-auto max-w-xl px-4 py-5 sm:py-8" data-id="element-98" data-mp="df6ti6u4n1iv">
        <SectionHeader onDark id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" title="Empieza hoy a organizar tus clases con un sistema listo para adaptar." data-id="element-99" data-mp="id8dqv3ah6vx" />

        <div className="mt-3 rounded-xl border-[3px] border-dashed border-energy bg-white p-4 text-center sm:p-5" data-id="element-100" data-mp="rdn1e13q6y2l">
          <p className="font-display text-sm font-extrabold text-electric sm:text-base" data-id="element-101" data-mp="wboiighlcnbf">⚡ {PRODUCT_NAME}</p>
          <p className="font-display text-sm font-bold text-navy" data-id="element-102" data-mp="2t6ud70k4qxjq">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm font-medium text-navy" data-id="element-103" data-mp="2y5fhpc6f03dz">🎁 Bonos valorados en {BONUS_TOTAL}</p>

          <p className="mx-auto mt-2 inline-block rounded bg-spark px-3 py-1 font-display text-xs font-extrabold text-navy" data-id="element-104" data-mp="12ojwgd2oo4ma">
            🔥 Oferta especial
          </p>
          <p className="mt-1.5 font-display text-5xl font-black leading-none text-navy sm:text-6xl" data-id="element-105" data-mp="sx77puc6lukh">
            Hoy: <span className="text-electric" data-id="element-106" data-mp="own88k44yev6">{PRICE}</span>
          </p>
          <p className="mt-1.5 text-xs font-medium text-navy/70 sm:text-sm" data-id="element-107" data-mp="1lme52pzwge45">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} className="mt-3" data-id="element-108" data-mp="1gol0u2i5pu6i">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>
          <p className="mt-1.5 text-xs font-medium text-navy/70" data-id="element-109" data-mp="1cniyhcsy120b">Acceso Inmediato • Garantía de 7 Días</p>
        </div>
      </div>
    </section>;
}